<script setup lang="ts">
/**
 * The button in the top right corner of a CV preview, so the way out is where
 * the eyes already are: the PDF's download, or putting the web CV online. The
 * offers column decides what it does (LandingResultOffers `cornerDownload`,
 * `cornerWebsite`). A paid step is green, a free one dark.
 */
withDefaults(defineProps<{
  /** "Download free", "Download for $4.90", "Make it online"… */
  label: string
  busy?: boolean
  paid?: boolean
  icon?: string
}>(), {
  busy: false,
  paid: false,
  icon: 'bi-download',
})

const emit = defineEmits<{ click: [] }>()
</script>

<template>
  <button
    type="button"
    class="absolute right-3 top-3 z-10 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold shadow-lift transition-opacity hover:opacity-90 disabled:opacity-60"
    :class="paid ? 'bg-accent-strong !text-white' : 'bg-ink !text-white dark:bg-white dark:!text-ink'"
    :disabled="busy"
    @click="emit('click')"
  >
    <span v-if="busy" class="inline-block size-4 animate-spin rounded-full border-2 border-current border-t-transparent" aria-hidden="true" />
    <i v-else class="bi" :class="icon" aria-hidden="true" />
    {{ label }}
  </button>
</template>
